export default __webpack_public_path__ + "static/media/header-img.0bf5085d.gif";